/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-09-28 18:26:02
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';

import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Icon } from '@shopify/polaris';
import { CaretDownMinor, CaretUpMinor } from '@shopify/polaris-icons';
import { CSSTransition } from 'react-transition-group';

import WidgetRow from './widget-row';
import { RenderTooltip } from 'src/components/views/common/render-tooltip';

import { RECOMMENDATION_WIDGET_PAGE_TYPES, COLUMN_WIDGET } from 'src/constants/recommendation';

type Props = {
  key: number,
  index: number,
  pageType: string,
  isApplyFilter: boolean,
  widgets: Array<Object>,
  handleWidgetAction: Function,
  deleting: boolean,
  success: boolean,
  saving: boolean,
  hasAddonAIPowerRecommendation: boolean,
  enablePersonalizedRec: Boolean,
  selectedTab: number,
  handleUnlock: Function
};

type ComposedProps = Props & WithI18nProps;

type State = {
  active: boolean
};

class PageTypeCollapse extends Component<ComposedProps, State> {
  state = {
    active: false
  };

  componentDidMount() {
    this.activeCollapse();
  }

  componentDidUpdate(prevProps) {
    const { isApplyFilter } = this.props;
    const { isApplyFilter: isApplyFilterPrev } = prevProps;
    const idPrev = _.get(prevProps, 'widgets[0].id', '');
    const id = _.get(this.props, 'widgets[0].id', '');
    if (idPrev !== id || isApplyFilter !== isApplyFilterPrev) {
      this.activeCollapse();
    }
  }
  render() {
    const {
      i18n,
      pageType,
      index,
      widgets = [],
      saving,
      deleting,
      success,
      tenantApp,
      handleWidgetAction,
      isApplyFilter,
      hasAddonAIPowerRecommendation,
      enablePersonalizedRec,
      selectedTab,
      handleUnlock
    } = this.props;
    const { active } = this.state;
    const noWidget = widgets.length === 0;

    return (
      <div
        className={`Polaris-DataTable recommendation-widget-table ${
          active ? ' active' : 'not-active'
        }`}
        key={index}>
        <div className="page-type" onClick={this.toggleContent}>
          <span className="page-type-collapse-icon">
            <Icon source={active ? CaretDownMinor : CaretUpMinor} color="base" />
          </span>

          <p className="page-type-title">
            <Icon source={RECOMMENDATION_WIDGET_PAGE_TYPES[pageType].icon} color="highlight" />
            <span>{i18n.translate(RECOMMENDATION_WIDGET_PAGE_TYPES[pageType].name)}</span>
          </p>
        </div>
        {/* Render table header */}
        <CSSTransition
          in={active}
          timeout={200}
          classNames="item-transition transition"
          unmountOnExit>
          <table className="Polaris-DataTable__Table">
            <thead>
              <tr>
                {_.map(COLUMN_WIDGET, (column, index) => (
                  <td
                    style={{
                      width: `${selectedTab !== 1 ? column.width : column.width2}%`,
                      textAlign: `${column.textAlign}`
                    }}
                    key={index}
                    className={`Polaris-DataTable__Cell Polaris-DataTable__Cell--header`}>
                    <div style={{ fontWeight: '600' }} data-tut={column.value}>
                      {i18n.translate(`AdminHTML.Recommendation.WidgetTable.${column.label}`)}
                      {column.tooltip ? (
                        <span style={{ fontWeight: 'normal' }}>
                          <RenderTooltip
                            content={i18n.translate(
                              `AdminHTML.Recommendation.WidgetTable.${column.tooltip}`
                            )}
                            icon={true}
                          />
                        </span>
                      ) : (
                        ''
                      )}
                    </div>
                  </td>
                ))}
              </tr>
            </thead>
            <tbody className={`Polaris-DataTable__Table recommendation-collapse `}>
              {noWidget ? (
                <tr>
                  <td className="no-widget-recommendation" colSpan={7}>
                    {i18n.translate(
                      `AdminHTML.Recommendation.WidgetDashboard.${
                        isApplyFilter ? 'noSearchResult_PageType' : 'noWidget'
                      }`
                    )}
                  </td>
                </tr>
              ) : (
                <>
                  {_.map(widgets, (item, index) => (
                    <WidgetRow
                      key={index}
                      widget={item}
                      success={success}
                      deleting={deleting}
                      index={index}
                      saving={saving}
                      tenantApp={tenantApp}
                      hasAddonAIPowerRecommendation={hasAddonAIPowerRecommendation}
                      enablePersonalizedRec={enablePersonalizedRec}
                      selectedTab={selectedTab}
                      handleWidgetAction={handleWidgetAction}
                      handleUnlock={handleUnlock}
                    />
                  ))}
                </>
              )}
            </tbody>
          </table>
        </CSSTransition>
      </div>
    );
  }
  activeCollapse = () => {
    const { widgets = [] } = this.props;
    let active = false;
    if (widgets && widgets.length > 0) {
      active = true;
    }
    this.setState({ active });
  };
  toggleContent = () => {
    this.setState(({ active }) => ({
      active: !active
    }));
  };
}

export default withI18n()(PageTypeCollapse);
